package com.github.dwursteisen.minigdx.demo

import com.github.dwursteisen.minigdx.GameApplicationBuilder
import com.github.dwursteisen.minigdx.GameConfiguration
import com.github.dwursteisen.minigdx.GameScreenConfiguration
import com.github.dwursteisen.minigdx.Percent
import gmtkjam.TrijamGame
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.get
import kotlin.browser.document
import kotlin.browser.window


val loadingProgress = { progress: Percent ->
    println(progress)
    val percent = progress.toFloat()
    val tag = document.getElementById("loading")
    val result = if (percent < 0.25f) {
        "loading…"
    } else if (percent < 0.5f) {
        "(still) loading…"
    } else if (percent < 0.75f) {
        "almost loaded"
    } else {
        "Loaded!"
    }
    tag?.textContent = result
}

@ExperimentalStdlibApi
fun main() {
    val canvas = document.getElementsByTagName("canvas")[0]!!
    var rootPath = window.location.protocol + "//" + window.location.host + window.location.pathname
    // make it itchio compatible
    rootPath = rootPath.replace("index.html", "")
    GameApplicationBuilder(
        gameConfigurationFactory = {
            GameConfiguration(
                gameScreenConfiguration = GameScreenConfiguration.WithResolution(1920, 1080),
                canvas = canvas as HTMLCanvasElement,
                rootPath = rootPath,
                debug = false,
                gameName = "Trijam",
                loadingListener = loadingProgress
            )

        },
        gameFactory = {
            TrijamGame(it)

        }
    ).start()
}
